import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client, { apiCall } from '../api/client';
import PricingCard from '../components/PricingCard';
import Loader from '../components/Loader';
import { useAuth } from '../context/AuthContext';

export default function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [activePlanId, setActivePlanId] = useState('');
  const [error, setError] = useState('');
  const [subscribing, setSubscribing] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    apiCall(client.get('/credit_plan/get_list'))
      .then(setPlans)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
    if (user) {
      apiCall(client.get('/credit_plan/active'))
        .then((plan) => setActivePlanId(plan.planId))
        .catch(() => setActivePlanId(''));
    }
  };

  useEffect(load, [user]);

  const handleSelect = async (plan) => {
    if (!user) {
      navigate('/signup');
      return;
    }
    setError('');
    setSubscribing(plan.uniqueId);
    try {
      await apiCall(client.post('/credit_plan/subscribe', { planId: plan.uniqueId }));
      navigate('/dashboard/billing');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubscribing('');
    }
  };

  return (
    <div className="section">
      <div className="container">
        <div className="section-header">
          <h2>Predictable pricing that scales with you</h2>
          <p>
            Every plan ships with built-in redundancy and real-time usage tracking out of the box.
            Start free, upgrade the moment you need more throughput — no lock-in, no surprises.
          </p>
        </div>
        {error && (
          <div className="form-error" style={{ maxWidth: 480, margin: '0 auto 24px', textAlign: 'center' }}>
            {error}
            {error.toLowerCase().includes('insufficient wallet balance') && (
              <> <Link to="/dashboard/wallet">Deposit funds</Link></>
            )}
          </div>
        )}
        {loading ? (
          <Loader label="Loading plans..." />
        ) : (
          <div className="pricing-grid">
            {plans.map((plan, i) => (
              <PricingCard
                key={plan.uniqueId}
                plan={plan}
                featured={i === 1}
                isCurrent={plan.uniqueId === activePlanId}
                ctaLabel={subscribing === plan.uniqueId ? 'Activating...' : undefined}
                onSelect={handleSelect}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
